export default [

     {
          path: '/drill-type',
          name: 'DrillType',
          component: () => import("@/views/Page/DrillType/DrillType.vue"),
           meta: {
               title: '#Default# | DrillType',
          },
     }
];